module.exports = __webpack_public_path__ + "static/assets/4f988a8e4b8baef7fbf5686390e97ab5.svg";